<template>
  <el-dialog
    title="选择标签"
    class="tag-dialog"
    :visible.sync="dialogVisible"
    append-to-body
    width="300px"
  >
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
    <span class="title">常用标签</span>
    <el-tree
      :data="commonTags"
      node-key="ID"
      :filter-node-method="filterNode"
      ref="commonTagTree"
      default-expand-all
      :expand-on-click-node="false"
      @node-click="commonTagsClick"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <div class="row">
          <span class="icon-span" :style="getColor(data.COLOR)">
            <i class="el-icon-price-tag"></i>
          </span>
          <span style="margin-left: 10px;font-size: 14px;">{{data.TAGNAME}}</span>
          <span style="margin-left: auto;" v-show="data.IsSelect">
            <i class="el-icon-check"></i>
          </span>
        </div>
      </span>
    </el-tree>
    <span class="title">所有标签</span>
    <el-scrollbar style="height:250px">
      <el-tree
        :data="allTags"
        ref="allTagTree"
        node-key="ID"
        :filter-node-method="filterNode"
        default-expand-all
        :expand-on-click-node="false"
        @node-click="allTagsClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <div class="row">
            <span class="icon-span" :style="getColor(data.COLOR)">
              <i class="el-icon-price-tag"></i>
            </span>
            <span style="margin-left: 10px;font-size: 14px;">{{data.TAGNAME}}</span>
            <span style="margin-left: auto;" v-show="data.IsSelect">
              <i class="el-icon-check"></i>
            </span>
          </div>
        </span>
      </el-tree>
    </el-scrollbar>

    <ul class="dialog-footer">
      <li>
        <el-link
          :underline="false"
          @click="createTag"
          type="primary"
          icon="el-icon-circle-plus"
        >创建新标签</el-link>
      </li>
      <li>
        <el-link :underline="false" @click="tagManage" type="primary" icon="el-icon-s-grid">标签管理</el-link>
      </li>
    </ul>
    <span slot="footer" v-show="showFootButton">
      <el-button type="primary" @click="saveTag">确定</el-button>
      <el-button @click="dialogVisible=false">取消</el-button>
    </span>
    <CreateTag ref="createTag" @success="refershSource"></CreateTag>
    <TagManage ref="tagManage" :tagsource="tagSource" @success="refershSource"></TagManage>
  </el-dialog>
</template>

//标签选择

<script>
import { getAllTag, getCommonTag } from "@/api/modules/basicData/task";
import CreateTag from "./CreateTag.vue";
import TagManage from "./TagManage.vue";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  components: {
    CreateTag,
    TagManage,
  },
  props: {
    tagIds: {
      type: Array,
      default: () => [],
    },
    showFootButton: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      treeheight: 100,
      dialogVisible: false,
      filterText: "",
      commonTags: [],
      tagSource: [],
      allTags: [],
    };
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        this.refershSource();
      }
    },
    tagIds(newArr) {
      console.log("TagIds watched", newArr);
      if (newArr) {
        if (this.allTags) {
          this.allTags.forEach((o) => {
            o.IsSelect = newArr.some((id) => id == o.ID);
          });
          if (this.commonTags) {
            this.commonTags.forEach((o) => {
              o.IsSelect = newArr.some((id) => id == o.TAGID);
            });
          }
        }
      }
    },
    filterText(val) {
      this.$refs.commonTagTree.filter(val);
      this.$refs.allTagTree.filter(val);
    },
  },
  computed: {
    treeHeightStyle() {
      return "height: " + this.treeheight > 400 ? 400 : this.treeheight + "px;";
    },
  },
  mounted() {},
  methods: {
    saveTag() {
      this.dialogVisible = false;
      let selectTags = this.allTags.filter((o) => o.IsSelect);
      console.log("selectTags", selectTags);
      this.$emit("success", selectTags);
    },
    getColor(color) {
      return `color:${color}`;
    },
    refershSource() {
      let promise1 = getCommonTag(cookieUser.userId).then((result) => {
        result.forEach((o) => (o.IsSelect = false));
        if (this.tagIds) {
          result.forEach((o) => {
            o.IsSelect = this.tagIds.some((id) => id == o.TAGID);
          });
        }
        this.commonTags = result;
      });
      let promise2 = getAllTag().then((result) => {
        result.forEach((o) => (o.IsSelect = false));
        if (this.tagIds) {
          result.forEach((o) => {
            o.IsSelect = this.tagIds.some((id) => id == o.ID);
          });
        }
        this.allTags = result;
      });
      Promise.all([promise1, promise2]).then((values) => {
        this.tagSource = [this.commonTags, this.allTags];
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.TAGNAME.indexOf(value) !== -1;
    },
    commonTagsClick(data, node) {
      if (data.IsSelect) {
        data.IsSelect = false;
      } else {
        data.IsSelect = true;
      }
      let curTag = this.allTags.find((o) => o.ID == data.TAGID);
      if (curTag) {
        curTag.IsSelect = data.IsSelect;
        this.$emit("getValue", curTag);
      }
    },
    allTagsClick(data, node) {
      if (data.IsSelect) {
        data.IsSelect = false;
      } else {
        data.IsSelect = true;
      }

      console.log("allTagsClick", data.IsSelect);
      let commonTag = this.commonTags.find((o) => o.TAGID == data.ID);
      if (commonTag) {
        commonTag.IsSelect = data.IsSelect;
      }
      this.$emit("getValue", data);
    },
    createTag() {
      this.$refs.createTag.dialogVisible = true;
    },
    tagManage() {
      this.$refs.tagManage.open(this.tagSource);
    },
  },
};
</script>

<style scoped>
.tag-dialog .el-scrollbar__wrap {
  overflow-x: hidden !important;
}
.tag-dialog .el-dialog__body {
  padding: 10px 20px;
}
</style><style lang="scss" scoped>
.title {
  line-height: 30px;
  padding: 5px;
  font-size: 13px;
  color: #c1c1c1;
}
.custom-tree-node {
  width: 90%;
}
.row {
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 5px;
}

.icon-span {
  color: #22d7bb;
  font-size: 18px;
}

.dialog-footer {
  border-top: 1px solid #f3f3f3;
  text-align: left;
  padding-top: 5px;

  a {
    font-size: 16px;
  }

  a :hover {
    font-size: 16px;
    margin-left: 2px;
  }
}
</style>
